module.exports = __webpack_public_path__ + "static/img/theme22.504dc7b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/theme22.jpeg
// module id = VbOw
// module chunks = 1